








import { Wormhole } from 'portal-vue'
import { Component, Vue } from 'vue-property-decorator'

import FooterMedExperience from '@/components/FooterMedExperience.vue'
import FooterSailCroatia from '@/components/FooterSailCroatia.vue'

@Component({
  components: {
    FooterSailCroatia,
    FooterMedExperience,
  },
})
export default class Footer extends Vue {
  get footerButtonExists(): boolean {
    return Wormhole.hasContentFor('footer-button')
  }
}
